var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"position":"relative"},attrs:{"title":_vm.tooltip}},[_c('v-icon',{class:{'custom-large': _vm.large},staticStyle:{"border-radius":"0"},attrs:{"color":_vm.color,"large":_vm.large},domProps:{"textContent":_vm._s(_vm.iconText)}}),_vm._v(" "),(_vm.tvdecoder.is_menu_player)?_c('v-icon',{staticClass:"menu",staticStyle:{"position":"absolute","left":"0","top":"0"},style:({
        transform: _vm.menuPlayerIconTransform,
      }),attrs:{"color":_vm.color}},[_vm._v("restaurant")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IconTvDecoder.vue?vue&type=template&id=4f6b82b7&scoped=true&
// module id = 1839
// module chunks = 5